import * as Types from "../../../constants";
import produce from "immer";

let initialState = {
  logs: [],
  total: 0,
};
export default (state = initialState, action = {}) => {
  return produce(state, draft => {
    switch (action.type) {
      case Types.GET_ALL_LOGS:
        let data = action.logs.data
        draft.logs = data;
        draft.total = action.logs.total;
        break;
      default:
        return state;
    }
  })
}

